import { render, staticRenderFns } from "./CustomerImportOverview.vue?vue&type=template&id=4ecc1c9a&scoped=true&"
import script from "./CustomerImportOverview.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportOverview.vue?vue&type=style&index=0&id=4ecc1c9a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc1c9a",
  null
  
)

export default component.exports